import { TreeView } from "@progress/kendo-react-treeview";

function CustomTreeBranch(props) {
    function getIcon() {
        const icons = {
            "Split Section": "far fa-send-backward",
            "Stacked Section": "far fa-layer-group",
            "Split View": "far fa-columns",
            Heading: "far fa-heading",
            List: "far fa-list-ul",
            Kanban: "fa-duotone fa-grid",
            Cards: "far fa-credit-card-blank",
            Table: "far fa-table",
            Calendar: "far fa-calendar",
            "Gantt Chart": "far fa-stream",
            "Tab Container": "far fa-box",
            Tab: "far fa-box",
            Summary: "far fa-clipboard",
            Content: "far fa-image",
            View: "far fa-file-spreadsheet",
            Form: "far fa-address-card",
            "Progress Bar": "far fa-battery-half",
            Reference: "far fa-retweet",
            History: "far fa-history",
            Discussion: "far fa-comments",
        };

        return icons[props.item.componentType] || "far fa-list-alt";
    };

    function handleContextMenu(e) {
        props.handleContextMenu(e, props.item);
    };

    return (
        <span
            className="tree_branch"
            onClick={props.closeMenu}
            onContextMenu={handleContextMenu}
        >
            {props.item.componentType === "Stacked Section" ||
                props.item.componentType === "Split Section" ||
                props.item.componentType === "Tab Container" ||
                props.item.componentType === "Tab" ? (
                <span
                    className="add-sub-component"
                    onClick={(event) =>
                        props.showAddSubItem(event, props.item)
                    }
                >
                    <i className="fas fa-plus" key="0"></i>
                </span>
            ) : (
                <span></span>
            )}
            &nbsp;
            <span className="component-icon">
                <i className={getIcon()}></i>
            </span>
            &nbsp;
            {props.item.hidden ? (
                <del>{props.item.text}</del>
            ) : (
                <span>{props.item.text}</span>
            )}
        </span>
    );
}

function ComponentsTreeView(treeViewProps) {
    return (
        <TreeView
            { ...treeViewProps }
            expandIcons={true}
            item={(props) => (
                <CustomTreeBranch
                    item={props.item}
                    closeMenu={
                        treeViewProps.onContextMenu
                    }
                    showAddSubItem={
                        treeViewProps.showAddSubItem
                    }
                    handleContextMenu={
                        treeViewProps.onContextMenu
                    }
                />
            )}
        />
    )
}

export default ComponentsTreeView;